<template>
    <div>
        <!-- RESTABLECER CONTRASEÑA-->
        <v-layout>
          <v-dialog v-model="dialogforgetpassword" max-width="500">
            <form @submit.prevent="emailvalidate">
              <v-card>
                <v-layout justify-center>
                  <v-card-title style="font-size:20px">Introduce el email que usaste para registrarte</v-card-title>
                </v-layout>
                <v-layout justify-center>
                  <v-flex xs10 sm10 md10 > 
                    <v-text-field :rules="[rules.required]" required v-model="forgetpassword.email" label="Email" id="emailforgetpassword">                        
                    </v-text-field>
                    <v-layout v-if="userexistforgetpassword">
                      <label class ="fas fa-exclamation-triangle"> Usuario no Registrado, por favor Registrese</label>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-card-actions>
                  <v-layout justify-center>
                    <v-btn type="submit" color="#11679a" style="align:center;color:white">RESTABLECER</v-btn> 
                  </v-layout>
                </v-card-actions>
              </v-card>
            </form>
          </v-dialog>
        </v-layout> 
        <!-- CODIGO DE CONFIRMACION-->
        <v-layout justify-center>
          <v-dialog v-model="dialogvalidatecode" max-width="600"> 
            <form @submit.prevent="validatetokenandpassword">
              <v-card>
                <v-layout justify-center>
                  <v-card-title style="font-size:20px">Introduce el codigo de confirmacion</v-card-title>
                </v-layout>
                <v-layout justify-center>
                  <v-flex xs10 sm10 md10 > 
                    <v-text-field  :rules="[rules.required]" v-model="forgetpassword.codesegurity" id="token" required label="Introducir codigo">                       
                    </v-text-field>
                    <v-layout v-if="tokenvalidateerror">
                      <label class ="fas fa-exclamation-triangle">Código no valido</label>
                    </v-layout>
                  </v-flex>
                </v-layout >
                <v-layout justify-center>
                  <v-flex xs10 sm10 md10 >
                    <label style="text-align:center">¿No te llego el codigo? Prueba esto: </label>
                    <a @click="emailvalidate" style="color:black; font-weight:bold">    Reenviar codigo </a >
                  </v-flex>
                </v-layout>
                <v-layout justify-center>
                  <v-btn  type="submit" color="#11679a" style="text-align:center;color:white">ENVIAR CÓDIGO</v-btn>
                </v-layout> 
                <v-card-actions>
                  <v-layout justify-center>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </form>
          </v-dialog>
        </v-layout> 
        <!-- NUEVA CONTRASEÑA-->
        <v-layout justify-center>
          <v-flex xs10 sm10 md10 >
            <v-dialog v-model="dialogchangepassword" max-width="600"> 
              <form @submit.prevent="validatetokenandpassword">
                <v-card>
                  <v-layout justify-center >
                    <v-card-title style="font-size:20px">Cambiar contraseña</v-card-title>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex xs10 sm10 md10 > 
                        <v-card-title style="font-size:12px,text-align:center">Por favor introduce tu nueva contraseña <br>Recuerda que la contraseña distingue entre mayusculas y minusculas<br></v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex xs10 sm10 md10 > 
                      <v-text-field id="passreg" :append-icon="showforgetpassword  ? 'visibility_off' : 'visibility'" :type="showforgetpassword ? 
                        'text' : 'password'" @click:append="showforgetpassword = !showforgetpassword" :rules="[rules.required]" 
                        v-model="forgetpassword.password" required  label="Nueva contraseña">
                      </v-text-field>
                      <v-layout v-if="passlength">
                        <label id= "erroremptyname" class ="fas fa-exclamation-triangle">Tu contraseña debe tener 8 caracteres</label>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center>
                    <v-flex xs10 sm10 md10 > 
                      <v-text-field :append-icon="showforgetpasswordconfirm  ? 'visibility_off' : 'visibility'" :type="showforgetpasswordconfirm ? 'text' : 
                        'password'" @click:append="showforgetpasswordconfirm  = !showforgetpasswordconfirm " :rules="[rules.required]"  required id="passreg2"  
                        label="Confirmar contraseña">
                      </v-text-field>
                      <v-layout v-if="passequalserror">
                        <label id= "erroremptyname" class ="fas fa-exclamation-triangle">La Contraseña no coincide con la anterior</label>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-card-actions>
                    <v-layout justify-center>
                      <v-btn type="submit" color="#11679a" style="align:center;color:white">ACEPTAR</v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </form>
            </v-dialog>
          </v-flex>
        </v-layout> 
    </div>
</template>
<script>
import { EventBus } from '../../../helpers/eventbus/event-bus'
const alertify = require('alertifyjs')

import initVue from '../../../helpers/initVue'
// Modelos
import forgetpassword from '../../../models/forgetpassword'

import {
    mapGetters,
    mapActions
} from 'vuex'
  export default {
      data () {
       return {
          valid: true,
          InputLoginPassword: false,
          showforgetpassword: false,
          showforgetpasswordconfirm: false,
          modalsocialnetwork: false,
          socialnetworkurl: '',
          forgetpassword : new forgetpassword(),
          userexist: false,
          incorrectpassword: false,
          identity: null,
          userexistforgetpassword: false,
          passequalserror: false,
          passvalidate: false,
          passlength: false,
          token: null,
          session: false,
          state: false,
          dialogforgetpassword: false,
          modallogin:false,
          tokenvalidateerror: false,
          dialogvalidatecode: false,
          dialogchangepassword:false,
          rules: {
            required: value => !!value || 'Requerido.',
            min: v =>  v && v.length >= 8 || 'Minimo 8 caracteres',
            passwordvalidate: value => {
              const pattern = /^(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ]/
              return pattern.test(value) || 'Tu contraseña debe tener un carácter, una letra mayúscula, una minúscula y un número'
            },
            emailMatch: () => ('El correo electrónico y la contraseña que ingresaste no coinciden'),
            passwordspace: value =>{
              const pattern = /\s/
              return !pattern.test(value) || 'No dejes espacios en blanco'
            }
          }
        }
      },
      computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
      }),
      

      mounted(){
        this.getidentity()
        EventBus.$on('opendialogforgetpassword',()=>{
            this.opendialogforgetpassword()
        })
        
      },
      methods: {
        
        opendialogforgetpassword(){
          this.dialogforgetpassword=true
        },
        opendialogvalidatecode(){
          this.dialogvalidatecode=true
           this.dialogforgetpassword=false
        },
        opendialogchangepassword(){
          this.dialogchangepassword=true
           this.dialogvalidatecode=false
        },
        Finalizemodalforgetpassword(){
          this.dialogchangepassword=false
          
        },

        goLogin(){
          this.modallogin = true
        },

        /*******************************************************
 * * Obteniendo la identidad para validar el token
 *******************************************************/
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.identity)
        },
        
        /****************** * Guardar datos para identificar si el usuarios ha iniciado sesión ***************************************************+*/
        saveIdentity() {
            this.$store.dispatch('saveIdentity', this.identity)
            localStorage.setItem('iden', JSON.stringify(this.identity))
            this.$store.dispatch('saveToken', this.token)
            localStorage.setItem('tok', this.token)
        },
        
//Validar email y enviar código
        emailvalidate(){
            this.axios.put('users/forgetpasswordsendemail',this.forgetpassword)
                .then((res) => {
                  this.opendialogvalidatecode()
                })
                .catch((err) => {
                  console.log(err)
                  let msg = err.response.data.message

                    if (msg === "Usuario no Registrado") {
                        this.userexistforgetpassword = true
                        document.getElementById('emailforgetpassword').focus()
                        setTimeout(() => {
                            this.userexistforgetpassword = false
                        }, 5000)
                    }
                })
        },

        validatetokenandpassword(){
          let statetrue = this.state === true
        
          if(statetrue){
            const passuser = document.getElementById('passreg').value
            const passuserconfirm = document.getElementById('passreg2').value
            const desequalpassword = passuser != passuserconfirm
            const tamañopassword = passuser.length < 8
            if(desequalpassword){
              this.passequalserror=true
              document.getElementById('passreg2').focus()
                setTimeout(() => {
                    this.passequalserror=false
                }, 5000)
            }else if(tamañopassword){
                this.passlength=true
                document.getElementById('passreg').focus()
                setTimeout(() => {
                    this.passlength=false
                }, 5000)
            }else{
              this.axios.put(`users/forgetpasswordvalidatetoken/${this.state}`,this.forgetpassword)
                    .then((res) => {
                      this.Finalizemodalforgetpassword()
                      alertify.success('Contraseña Editada, puede Iniciar Sesión')
                      this.state = false
                    })
                    .catch((err) => {
                      console.log(err)
                    })
            }
          }else{
            this.axios.put(`users/forgetpasswordvalidatetoken/${this.state}`,this.forgetpassword)
                  .then((res) => {
                    this.opendialogchangepassword()
                    //console.log(res.data.success)
                    this.state = res.data.success
                    //console.log(this.state)
                  })
                  .catch((err) => {
                    console.log(err)
                    let msg = err.response.data.message

                      if (msg === "No coinciden") {
                          this.tokenvalidateerror = true
                          document.getElementById('token').focus()
                          setTimeout(() => {
                              this.tokenvalidateerror = false
                          }, 5000)
                      }
                  })
          }
        }

      }
      
}
  

</script>